import { render, staticRenderFns } from "./ProductIntroductionItemPreview.vue?vue&type=template&id=5580106f&scoped=true&"
import script from "./ProductIntroductionItemPreview.vue?vue&type=script&lang=js&"
export * from "./ProductIntroductionItemPreview.vue?vue&type=script&lang=js&"
import style0 from "./ProductIntroductionItemPreview.vue?vue&type=style&index=0&id=5580106f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5580106f",
  null
  
)

export default component.exports